/* Universal card-click navigation for any element with [data-product-url].
   Clicking on a button, link, form, or interactive child does NOT navigate. */

(function () {
  const INTERACTIVE_SELECTOR = 'button, a, input, select, textarea, label, [role="button"], product-form, .catalogue-card__arrow, .catalogue-card__dots';

  function bind(card) {
    if (card.dataset.cardClickBound === '1') return;
    card.dataset.cardClickBound = '1';

    const url = card.dataset.productUrl;
    if (!url) return;

    card.addEventListener('click', (e) => {
      if (e.target.closest(INTERACTIVE_SELECTOR)) return;
      if (window.getSelection && window.getSelection().toString()) return;
      window.location.href = url;
    });

    card.addEventListener('keydown', (e) => {
      if (e.target !== card) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        window.location.href = url;
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-product-url]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
